// A que notas um boleto se refere, em uma frase ([DA-630], 27/08/2026).
//
// 🔑 **E' o pedido dele resolvido sem digitar nada.** Ele pediu um campo pra informar o
// numero da nota fiscal no boleto; o sistema ja sabe (a ligacao titulo → orcamento →
// nota alimenta o AppCel desde a [DA-590]), e digitar criaria uma segunda verdade que
// nada delata. Este texto e' o que o cliente le pra lancar o boleto no contas a pagar
// da empresa dele.
//
// ⚠️ Mora no `shared` porque **texto visivel nao tem portao**: typecheck, testes de
// rota e smoke nao leem uma frase. Aqui ela tem teste proprio.

export interface NotaDeBoleto {
  tipo: 'nfe' | 'nfce';
  numero: number;
}

/** `NF-e 243` / `Cupom 1180` — o tipo vai escrito porque o mesmo NUMERO existe nas duas
 *  series, e o cliente distingue os dois papeis na mao. */
export function rotuloDaNota(n: NotaDeBoleto): string {
  return `${n.tipo === 'nfce' ? 'Cupom' : 'NF-e'} ${n.numero}`;
}

/**
 * A frase de referencia do boleto.
 *
 * ⚠️ **Sem nota nenhuma devolve `null`, e a tela nao desenha a linha** — "Referente a"
 * seguido de nada le como defeito. Acontece de verdade: titulo de consignacao nao tem
 * nota por pedido (9 dos 73 pendentes em 27/08/2026).
 *
 * ⛔ **Nao promete o que nao sabe.** Se o boleto cobre 3 titulos e so 2 tem nota, a
 * frase cita as duas e para — um "e outras" faria o cliente procurar um papel que a
 * loja nunca emitiu.
 */
export function referenciaDoBoleto(notas: NotaDeBoleto[]): string | null {
  if (!notas.length) return null;
  const nomes = notas.map(rotuloDaNota);
  if (nomes.length === 1) return `Referente a ${nomes[0]}`;
  // Virgula entre as primeiras e "e" antes da ultima — como se escreve, nao como se
  // concatena. `243, 244 e 245` le bem; `243, 244, 245` le como codigo.
  return `Referente a ${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}`;
}
